<app-breadcrumb [parentName]="'Korporacja'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group>
  <mat-tab label="Dane">
    <app-corporation-details-view *ngIf="!modify" [support]="support" (modifyClicked)="modify = true" (changed)="loadSupport()"></app-corporation-details-view>
    <app-corporation-add *ngIf="modify" [serviceTypeKeys]="supportObject.serviceType.key" [support]="support" (closeModification)="modify = false; loadSupport()"></app-corporation-add>
  </mat-tab>
  <mat-tab label="Historia zmian">
    <ng-template matTabContent>
      <app-log-list [support]="support"></app-log-list>
    </ng-template>
  </mat-tab>
</mat-tab-group>
